export default __webpack_public_path__ + "static/media/SM-Ex.d8b164db.png";